import { distanceUnits } from "../settings/distance-unit";
import { formatDistance as formatDistanceByUnit } from "../utilities/distance-format";
const meterGridCandidates = [
    0.1, 0.25, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000,
    20000, 50000,
];
const feetGridCandidates = [
    0.25, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000,
    50000,
];
const axisDecimals = 2;
const getGridCandidates = (unit) => {
    if (unit === distanceUnits.METERS) {
        return meterGridCandidates;
    }
    return feetGridCandidates;
};
const selectDisplayGridStep = (stepInDisplayUnit, candidates) => {
    return (candidates.find((candidate) => stepInDisplayUnit <= candidate) ??
        candidates[candidates.length - 1]);
};
const formatDisplayValue = (value, decimals) => {
    if (Math.abs(value - Math.round(value)) < 1e-9) {
        return value.toFixed(0);
    }
    return value.toFixed(decimals);
};
export const formatDistance = (distanceUnitPort, sceneMeters, decimals = axisDecimals) => {
    return formatDistanceByUnit(distanceUnitPort, sceneMeters, decimals);
};
/**
 * Creates a unit presentation dedicated to 2D view rendering.
 * @param distanceUnitPort Conversion port for the active display unit.
 * @returns Object that provides display formatting and grid-step resolution for 2D views.
 */
export const createView2DPresentation = (distanceUnitPort) => {
    return {
        formatDistance: (sceneMeters, decimals = axisDecimals) => {
            return formatDistance(distanceUnitPort, sceneMeters, decimals);
        },
        formatAxisValue: (sceneMeters, decimals = axisDecimals) => {
            const displayValue = distanceUnitPort.toDisplay(sceneMeters);
            return formatDisplayValue(displayValue, decimals);
        },
        formatFixed: (sceneMeters, decimals) => {
            const displayValue = distanceUnitPort.toDisplay(sceneMeters);
            return displayValue.toFixed(decimals);
        },
        resolveGridScale: (sceneStepMeters) => {
            const stepInDisplayUnit = distanceUnitPort.toDisplay(sceneStepMeters);
            const displayStepValue = selectDisplayGridStep(stepInDisplayUnit, getGridCandidates(distanceUnitPort.unit));
            return {
                sceneStepMeters: distanceUnitPort.toMeters(displayStepValue),
                displayStepValue,
                displayUnitLabel: distanceUnitPort.label,
            };
        },
        getUnitLabel: () => {
            return distanceUnitPort.label;
        },
    };
};
//# sourceMappingURL=view-2d-presentation.js.map